import { render, staticRenderFns } from "./FormStatus.vue?vue&type=template&id=2f880620&"
import script from "./FormStatus.vue?vue&type=script&lang=js&"
export * from "./FormStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports